import { render, staticRenderFns } from "./ResultsSecondary.vue?vue&type=template&id=5faf06c6&scoped=true&"
import script from "./ResultsSecondary.vue?vue&type=script&lang=js&"
export * from "./ResultsSecondary.vue?vue&type=script&lang=js&"
import style0 from "./ResultsSecondary.vue?vue&type=style&index=0&id=5faf06c6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5faf06c6",
  null
  
)

export default component.exports